"use strict";

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "@emotion/core", "recompose/onlyUpdateForKeys", "./helpers"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("@emotion/core"), require("recompose/onlyUpdateForKeys"), require("./helpers"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.core, global.onlyUpdateForKeys, global.helpers);
    global.undefined = mod.exports;
  }
})(void 0, function (exports, _react, _core, _onlyUpdateForKeys, _helpers) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Loader = undefined;

  var _react2 = _interopRequireDefault(_react);

  var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _templateObject2() {
    var data = _taggedTemplateLiteral(["\n  0% {left: -200%;right: 100%} \n  60% {left: 107%;right: -8%}\n  100% {left: 107%;right: -8%}\n"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  0% {left: -35%;right: 100%} \n  60% {left: 100%;right: -90%}\n  100% {left: 100%;right: -90%}\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  var _long = (0, _core.keyframes)(_templateObject());

  var _short = (0, _core.keyframes)(_templateObject2());

  var Loader = exports.Loader = function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Loader);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Loader)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "style", function (i) {
        var _this$props = _this.props,
            height = _this$props.height,
            color = _this$props.color,
            heightUnit = _this$props.heightUnit;
        return (
          /*#__PURE__*/
          (0, _core.css)("{position:absolute;height:", "".concat(height).concat(heightUnit), ";overflow:hidden;background-color:", color, ";background-clip:padding-box;display:block;border-radius:2px;will-change:left,right;animation-fill-mode:forwards;animation:", i === 1 ? _long : _short, " 2.1s ", i === 2 ? '1.15s' : '', " ", i === 1 ? 'cubic-bezier(0.65, 0.815, 0.735, 0.395)' : 'cubic-bezier(0.165, 0.84, 0.44, 1)', " infinite;}label:style;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
        );
      });

      _defineProperty(_assertThisInitialized(_this), "wrapper", function () {
        var _this$props2 = _this.props,
            width = _this$props2.width,
            height = _this$props2.height,
            color = _this$props2.color,
            heightUnit = _this$props2.heightUnit,
            widthUnit = _this$props2.widthUnit;
        var wrapper =
        /*#__PURE__*/
        (0, _core.css)("{position:relative;width:", "".concat(width).concat(widthUnit), ";height:", "".concat(height).concat(heightUnit), ";overflow:hidden;background-color:", (0, _helpers.calculateRgba)(color, 0.2), ";background-clip:padding-box;}label:wrapper;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
        return _this.props.css ?
        /*#__PURE__*/
        (0, _core.css)(wrapper, ";", _this.props.css, "label:wrapper;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9CYXJMb2FkZXIuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWtEaUMiLCJmaWxlIjoic3JjL0JhckxvYWRlci5qc3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBrZXlmcmFtZXMsIGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5pbXBvcnQgb25seVVwZGF0ZUZvcktleXMgZnJvbSAncmVjb21wb3NlL29ubHlVcGRhdGVGb3JLZXlzJztcbmltcG9ydCB7IGNhbGN1bGF0ZVJnYmEsIGhlaWdodFdpZHRoUHJvcHMsIGhlaWdodFdpZHRoRGVmYXVsdHMsIGhlaWdodFdpZHRoS2V5cyB9IGZyb20gJy4vaGVscGVycyc7XG5cbmNvbnN0IGxvbmcgPSBrZXlmcmFtZXNgXG4gIDAlIHtsZWZ0OiAtMzUlO3JpZ2h0OiAxMDAlfSBcbiAgNjAlIHtsZWZ0OiAxMDAlO3JpZ2h0OiAtOTAlfVxuICAxMDAlIHtsZWZ0OiAxMDAlO3JpZ2h0OiAtOTAlfVxuYDtcblxuY29uc3Qgc2hvcnQgPSBrZXlmcmFtZXNgXG4gIDAlIHtsZWZ0OiAtMjAwJTtyaWdodDogMTAwJX0gXG4gIDYwJSB7bGVmdDogMTA3JTtyaWdodDogLTglfVxuICAxMDAlIHtsZWZ0OiAxMDclO3JpZ2h0OiAtOCV9XG5gO1xuXG5leHBvcnQgY2xhc3MgTG9hZGVyIGV4dGVuZHMgUmVhY3QuQ29tcG9uZW50IHtcbiAgICBzdHlsZSA9IGkgPT4ge1xuICAgICAgY29uc3QgeyBoZWlnaHQsIGNvbG9yLCBoZWlnaHRVbml0IH0gPSB0aGlzLnByb3BzO1xuXG4gICAgICByZXR1cm4gY3NzYHtcbiAgICAgICAgICAgIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgICAgICAgICAgIGhlaWdodDogJHtgJHtoZWlnaHR9JHtoZWlnaHRVbml0fWB9O1xuICAgICAgICAgICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICAgICAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3J9O1xuICAgICAgICAgICAgYmFja2dyb3VuZC1jbGlwOiBwYWRkaW5nLWJveDtcbiAgICAgICAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgICAgICAgICAgYm9yZGVyLXJhZGl1czogMnB4O1xuICAgICAgICAgICAgd2lsbC1jaGFuZ2U6IGxlZnQsIHJpZ2h0O1xuICAgICAgICAgICAgYW5pbWF0aW9uLWZpbGwtbW9kZTogZm9yd2FyZHM7XG4gICAgICAgICAgICBhbmltYXRpb246ICR7aSA9PT0gMSA/IGxvbmcgOiBzaG9ydH0gMi4xcyAke2kgPT09IDIgPyAnMS4xNXMnIDogJyd9ICR7aSA9PT0gMSA/ICdjdWJpYy1iZXppZXIoMC42NSwgMC44MTUsIDAuNzM1LCAwLjM5NSknIDogJ2N1YmljLWJlemllcigwLjE2NSwgMC44NCwgMC40NCwgMSknfSBpbmZpbml0ZTtcbiAgICAgICAgfWA7XG4gICAgfTtcblxuICAgIHdyYXBwZXIgPSAoKSA9PiB7XG4gICAgICBjb25zdCB7XG4gICAgICAgIHdpZHRoLCBoZWlnaHQsIGNvbG9yLCBoZWlnaHRVbml0LCB3aWR0aFVuaXRcbiAgICAgIH0gPSB0aGlzLnByb3BzO1xuXG4gICAgICBjb25zdCB3cmFwcGVyID0gY3NzYHsgICAgICAgIFxuICAgICAgICAgICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgICAgICAgICAgd2lkdGg6ICR7YCR7d2lkdGh9JHt3aWR0aFVuaXR9YH07XG4gICAgICAgICAgICBoZWlnaHQ6ICR7YCR7aGVpZ2h0fSR7aGVpZ2h0VW5pdH1gfTtcbiAgICAgICAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICAgICAgICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NhbGN1bGF0ZVJnYmEoY29sb3IsIDAuMil9O1xuICAgICAgICAgICAgYmFja2dyb3VuZC1jbGlwOiBwYWRkaW5nLWJveDtcbiAgICAgICAgfWA7XG5cbiAgICAgIHJldHVybiB0aGlzLnByb3BzLmNzcyA/IGNzc2Ake3dyYXBwZXJ9OyR7dGhpcy5wcm9wcy5jc3N9YCA6IHdyYXBwZXI7XG4gICAgfTtcblxuICAgIHJlbmRlcigpIHtcbiAgICAgIGNvbnN0IHsgbG9hZGluZyB9ID0gdGhpcy5wcm9wcztcblxuICAgICAgcmV0dXJuIGxvYWRpbmcgP1xuICAgICAgICA8ZGl2IGNzcz17dGhpcy53cmFwcGVyKCl9PlxuICAgICAgICAgIDxkaXYgY3NzPXt0aGlzLnN0eWxlKDEpfSAvPlxuICAgICAgICAgIDxkaXYgY3NzPXt0aGlzLnN0eWxlKDIpfSAvPlxuICAgICAgICA8L2Rpdj4gOiBudWxsO1xuICAgIH1cbn1cblxuTG9hZGVyLnByb3BUeXBlcyA9IGhlaWdodFdpZHRoUHJvcHM7XG5cbkxvYWRlci5kZWZhdWx0UHJvcHMgPSBoZWlnaHRXaWR0aERlZmF1bHRzKDQsIDEwMCk7XG5cbmNvbnN0IENvbXBvbmVudCA9IG9ubHlVcGRhdGVGb3JLZXlzKGhlaWdodFdpZHRoS2V5cykoTG9hZGVyKTtcbkNvbXBvbmVudC5kZWZhdWx0UHJvcHMgPSBMb2FkZXIuZGVmYXVsdFByb3BzO1xuZXhwb3J0IGRlZmF1bHQgQ29tcG9uZW50O1xuIl19 */")) : wrapper;
      });

      return _this;
    }

    _createClass(Loader, [{
      key: "render",
      value: function render() {
        var loading = this.props.loading;
        return loading ? (0, _core.jsx)("div", {
          css: this.wrapper()
        }, (0, _core.jsx)("div", {
          css: this.style(1)
        }), (0, _core.jsx)("div", {
          css: this.style(2)
        })) : null;
      }
    }]);

    return Loader;
  }(_react2["default"].Component);

  Loader.propTypes = _helpers.heightWidthProps;
  Loader.defaultProps = (0, _helpers.heightWidthDefaults)(4, 100);
  var Component = (0, _onlyUpdateForKeys2["default"])(_helpers.heightWidthKeys)(Loader);
  Component.defaultProps = Loader.defaultProps;
  exports["default"] = Component;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-spinners/BarLoader.js
// module id = 894
// module chunks = 2